exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hs-navigation-forward {\n  top: 50%;\n  right: 20px;\n  position: fixed; }\n", ""]);

// exports
